// extracted by mini-css-extract-plugin
export default {"container":"GradesCell__container___MWvw_","tooltipSvgContainer":"GradesCell__tooltipSvgContainer___VhF3O","svgContainer":"GradesCell__svgContainer___XdSr1"};